import React from "react";

export default function Navbar(){
    return (
        <nav className="nav">
            <img src="image/troll-face.png" className="nav-img" alt="troll face"/>
            <h3 className="nav-title">MemeGenerator</h3>
            <h4 className="nav-project">React Course - Project 1</h4>
        </nav>
    )
}